module.exports = __webpack_public_path__ + "files/09fd7efb3b87a3f2f3993f9dda308a3d.png";